import { Api } from '../api';
import { cards } from '../endpoints';
import { GetCardsResponse } from '../misc';
import { AddCardRequest, TopupRequest, TopupResponse } from './models';

export class CardsApi extends Api {
  static getCards = (signal?: AbortSignal) => this.get<GetCardsResponse[]>({ url: cards.cards(), signal: signal });

  static addCard = (request: AddCardRequest, signal?: AbortSignal) =>
    this.post<AddCardRequest, undefined>({ url: cards.addCard(), data: request, signal: signal });

  static downloadStatement = (id: string, token: string, signal?: AbortSignal) =>
    this.get<undefined>({ url: cards.downloadStatement(id, token), signal: signal, responseType: 'blob' });

  static topup = (request: TopupRequest, cardId: string, signal?: AbortSignal) =>
    this.post<TopupRequest, TopupResponse>({ url: cards.topup(cardId), data: request, signal: signal });
}
